import { Card, Layout, theme } from 'antd';
import Title from 'antd/es/typography/Title';
import React from 'react';
const { Header, Content } = Layout;

export interface SubPageLayoutProps {
  header?: React.JSX.Element;
  children?: React.ReactNode;
  extra?: React.ReactNode;
  isOnlyContent?: boolean;
  isNonWhiteBackground?: boolean;
}

export const SubPageLayout: React.FC<SubPageLayoutProps> = (props) => {
  const {
    token: { colorText }
  } = theme.useToken();

  if (props.isOnlyContent) {
    return (
      <Layout style={{ minHeight: '100vh', marginTop: "50px" }}>
        <Content>{props.children}</Content>
      </Layout>
    );
  }

  return (
    <Card style={{  width: '100%', height: "100%", backgroundColor: props.isNonWhiteBackground? 'transparent' : '' }}>
      <Header style={{ padding: 0, color: colorText, backgroundColor: 'transparent' }}>
        {props.header}</Header>
      <Title
        level={2}
        style={{
          marginBottom: '40px'
        }}
      ></Title>
      {props.extra && <div style={{ marginTop: '-75px', padding: '10px', textAlign: 'right' }}>{props.extra}</div>}
      <Content>{props.children}</Content>
    </Card>
  );
};
